import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';

import { MerchantToolsComponent } from './merchant-tools.component';

export const merchantToolsModule = angular.module('ec.opsCenter.merchantTools', [])
  .directive('appMerchantTools', downgradeComponent({
    component: MerchantToolsComponent,
    inputs: ['merchant', 'currentIntegrationMigrationStatus', 'integrationPartnerSources', 'integrationPartnerSubSources'],
    propagateDigest: true
  }) as angular.IDirectiveFactory)
  .name;



// WEBPACK FOOTER //
// ./src/app/merchant-tools/merchant-tools.module.ajs.ts